/* HEARTBOOK sticky buy bar. Source: HQ-Groups brands/heartbook/store/sticky-2026-09-25/
   The bar button clicks Shrine's own (hidden) Add to cart button, and mirrors its state.
   Nạp async và định nghĩa ngay khi HTML dựng xong, KHÔNG chờ js.shrinetheme.com/main.js (file 218 KB, no-store,
   có lúc tải rất lâu): trước khi Shrine chạy, bấm nút = nút gốc gửi form thường (thêm giỏ rồi sang trang giỏ). */
window.hbWhenShrine = window.hbWhenShrine || function (fn) {
  // pub/sub của Shrine chỉ có sau main.js; DOMContentLoaded bắn sau khi mọi script defer (kể cả main.js) đã chạy
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') return fn();
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') fn();
  });
};
const hbDefineSticky = () => {
if (!customElements.get('hb-sticky-buy')) {
  customElements.define(
    'hb-sticky-buy',
    class HbStickyBuy extends HTMLElement {
      connectedCallback() {
        this.source = document.getElementById(this.dataset.buttonId);
        if (!this.source) {
          this.remove();
          return;
        }
        this.form = this.source.form || document.getElementById(this.source.getAttribute('form'));
        this.btn = this.querySelector('.hb-sticky__atc');
        this.label = this.querySelector('.hb-sticky__label');
        this.error = this.querySelector('.hb-sticky__error');
        try {
          this.variants = JSON.parse(this.querySelector('[data-hb-sticky-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }
        this.mobile = window.matchMedia('(max-width: 749px)');

        document.body.classList.add('hb-sticky-page');
        this.source.setAttribute('tabindex', '-1'); // nút gốc thu về 1px, không cho bàn phím dừng ở đó
        this.btn.addEventListener('click', (e) => this.buy(e));

        this.syncState();
        new MutationObserver(() => this.syncState()).observe(this.source, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.watchVariant();
        this.watchError();
        this.initShip();
        this.initPicker();

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.mobile.addEventListener('change', this.onScroll);
        this.onScroll();

        this.measure();
        if ('ResizeObserver' in window) new ResizeObserver(() => this.measure()).observe(this);
      }

      // 27/09 audit C14: gỡ khỏi trang (trình sửa theme vẽ lại section) thì dọn vòng hỏi + bộ nghe, không bỏ lại chạy ngầm
      disconnectedCallback() {
        clearInterval(this.t1);
        clearInterval(this.t2);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.mobile && this.onScroll) this.mobile.removeEventListener('change', this.onScroll);
      }

      buy(e) {
        if (e) e.preventDefault(); // nút là type=submit (dự phòng khi JS hỏng); có JS thì mình tự xử lý
        if (this.btn.disabled || this.btn.classList.contains('is-loading') || this.busy) return;
        if (this.error) this.error.hidden = true;
        if (!this.shrineReady()) return this.addDirect();
        this.source.click();
      }

      // Audit 27/09 C4: lõi Shrine (main.js, 218 KB, cấm cache) và Timesact (defer, chạy sau main.js) chưa tải xong thì nút gốc
      // gửi form thường KHÔNG có gói pre-order và không khoá nút (khách bấm 2 lần = 2 lần thêm). Lúc đó tự thêm giỏ, kèm gói
      // pre-order của đúng bản (bảng "plan" in từ máy chủ), khoá nút + vòng quay, rồi sang trang giỏ.
      shrineReady() {
        // tên trần như hbWhenShrine: PUB_SUB_EVENTS của Shrine có thể là const (không gắn vào window)
        return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !!customElements.get('product-form');
      }

      async addDirect() {
        this.busy = true;
        this.btn.classList.add('is-loading');
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const id = this.currentVariantId();
        const qEl = this.form && this.form.querySelector('[name="quantity"]');
        const quantity = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
        const v = this.variants.find((x) => String(x.id) === String(id));
        const item = { id: Number(id), quantity };
        if (v && v.plan) item.selling_plan = Number(v.plan);
        try {
          const r = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          });
          if (!r.ok) throw new Error('add ' + r.status);
          window.location.href = root + 'cart';
        } catch (err) {
          this.busy = false;
          this.btn.classList.remove('is-loading');
          if (this.form) this.form.submit(); // đường cuối: form thường của Shopify
        }
      }

      syncState() {
        const s = this.source;
        const unavailable = s.disabled || s.getAttribute('aria-disabled') === 'true';
        const loading = s.classList.contains('loading');
        this.btn.classList.toggle('is-loading', loading);
        this.btn.disabled = unavailable && !loading;
        // chép chữ trên nút gốc: Shrine ghi "Sold out", app pre-order ghi "Pre-order"
        const srcLabel = s.querySelector('.main-atc__label, .button__label');
        const text = srcLabel ? srcLabel.textContent.trim() : '';
        if (text && !loading) this.label.textContent = text;
        else if (!loading) this.label.textContent = unavailable ? this.dataset.soldLabel : this.dataset.addLabel;
      }

      currentVariantId() {
        const input = this.form && this.form.querySelector('input[name="id"]');
        return input ? String(input.value) : '';
      }

      watchVariant() {
        this.lastVariant = this.currentVariantId();
        const check = () => {
          const id = this.currentVariantId();
          if (id && id !== this.lastVariant) {
            this.lastVariant = id;
            this.renderVariant(id);
          }
        };
        if (this.form) this.form.addEventListener('change', check);
        window.hbWhenShrine(() => subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(check, 0)));
        this.t1 = setInterval(() => { if (!document.hidden) check(); }, 500); // 27/09 audit C14: không chạy khi tab ẩn
      }

      renderVariant(id) {
        const v = this.variants.find((x) => String(x.id) === String(id));
        if (!v) return;
        const set = (sel, fn) => {
          const el = this.querySelector(sel);
          if (el) fn(el);
        };
        this.renderShip();
        if (this.picker && this.picker.value !== String(v.id)) this.picker.value = String(v.id);
        set('.hb-sticky__variant', (el) => (el.textContent = v.title));
        set('.hb-sticky__now', (el) => (el.textContent = v.price));
        set('.hb-sticky__was', (el) => {
          el.textContent = v.compare || '';
          el.hidden = !v.compare;
        });
        if (v.image) {
          set('.hb-sticky__img', (el) => {
            el.removeAttribute('srcset');
            el.src = v.image;
          });
        }
        this.syncState();
      }

      watchError() {
        const wrap = this.source.closest('product-form');
        const box = wrap && wrap.querySelector('.product-form__error-message-wrapper');
        if (!box || !this.error) return;
        new MutationObserver(() => {
          const msg = box.querySelector('.product-form__error-message');
          const text = msg ? msg.textContent.trim() : '';
          if (!box.hidden && text) {
            this.error.textContent = text;
            this.error.hidden = false;
            clearTimeout(this.errorTimer);
            this.errorTimer = setTimeout(() => (this.error.hidden = true), 6000);
          }
        }).observe(box, { attributes: true, childList: true, subtree: true, characterData: true });
      }

      onScroll() {
        const offset = Number(this.dataset.mobileOffset || 0);
        const hide = this.mobile.matches && window.scrollY < offset;
        if (hide !== this.classList.contains('is-hidden')) {
          this.classList.toggle('is-hidden', hide);
          this.measure();
        }
      }

      /* ---- ô chọn bản trên thanh (desktop): đổi bản ở ô chọn GỐC trong khung mua để Shrine tự cập nhật giá, ảnh, form ---- */
      initPicker() {
        this.picker = this.querySelector('.hb-sticky__select');
        if (!this.picker) return;
        this.picker.addEventListener('change', () => {
          const opt = this.picker.selectedOptions[0];
          if (opt) this.pickVariant(opt.dataset.option);
        });
      }

      pickVariant(value) {
        const pickers = [...document.querySelectorAll('product-info variant-selects')];
        const vs = pickers.find((p) => p.offsetParent) || pickers[0];
        if (!vs) return;
        const selects = [...vs.querySelectorAll('select')];
        const sel = selects.find((x) => x.offsetParent) || selects[0];
        if (sel) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const input = [...vs.querySelectorAll('input[type="radio"]')].find((i) => i.value === value);
        if (input) {
          const label = vs.querySelector(`label[for="${input.id}"]`);
          (label || input).click();
        }
      }

      /* ---- dòng nhắc free ship: (tổng giỏ + số lượng đang chọn × giá bản đang chọn) so với ngưỡng ---- */
      initShip() {
        const box = this.querySelector('.hb-sticky__ship');
        if (!box) return;
        this.ship = {
          box,
          text: box.querySelector('.hb-sticky__ship-text'),
          add: box.querySelector('.hb-sticky__ship-add'),
          threshold: Number(box.dataset.threshold || 0),
          bagId: box.dataset.bagId || '',
          bagPrice: Number(box.dataset.bagPrice || 0),
        };
        const qtyWrap = document.getElementById(this.dataset.qtyId);
        this.qtyInput = qtyWrap && qtyWrap.querySelector('input[name="quantity"]');
        if (this.qtyInput) {
          this.qtyInput.addEventListener('change', () => this.renderShip());
          this.qtyInput.addEventListener('input', () => this.renderShip());
        }
        this.lastQty = this.currentQty();
        this.t2 = setInterval(() => {
          if (document.hidden) return;
          const q = this.currentQty();
          if (q !== this.lastQty) {
            this.lastQty = q;
            this.renderShip();
          }
        }, 400);
        if (this.ship.add) this.ship.add.addEventListener('click', () => this.addBag());
        window.hbWhenShrine(() => subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart()));
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          let wasOpen = drawer.classList.contains('active');
          new MutationObserver(() => {
            const open = drawer.classList.contains('active');
            if (wasOpen && !open) this.refreshCart(); // khách sửa giỏ trong ngăn kéo rồi đóng lại
            wasOpen = open;
          }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        }
        this.refreshCart();
      }

      currentQty() {
        const n = this.qtyInput ? parseInt(this.qtyInput.value, 10) : 1;
        return Number.isFinite(n) && n > 0 ? n : 1;
      }

      async refreshCart() {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await res.json();
          let total = Number(cart.total_price || 0);
          // Christmas Open 27–29/10/2026 (store/xmas-open-2026-10-27/HOP_DONG_KHACH_THAY.md, lệch 2): XMASEB gắn vào giỏ thì tính free ship
          // như thể cuốn Teachers $0. Nếu không trừ: lúc Teachers còn $19,95 thanh dính báo free ship, thêm 2 cuốn xong Teachers về $0,
          // giỏ còn $39,90 < $44 và báo thiếu $4,10. Cấu hình chung ở snippets/hb-cart-sync.liquid (window.HB_XO).
          // Hết sale (xo.end) hoặc hết 20 suất (xo.out) thì Teachers không còn free: thôi trừ.
          const xo = window.HB_XO;
          const live = xo && !xo.out && !(xo.end && Date.now() > xo.end);
          if (live && (cart.discount_codes || []).some((c) => xo.codes.indexOf(String(c.code || '').toUpperCase()) >= 0)) {
            (cart.items || []).forEach((i) => {
              if (String(i.variant_id) === String(xo.free)) total -= Number(i.final_line_price || 0);
            });
          }
          this.cartTotal = Math.max(0, total);
        } catch (e) {
          this.cartTotal = null;
        }
        this.renderShip();
      }

      money(cents) {
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100);
        } catch (e) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      }

      renderShip() {
        const sh = this.ship;
        if (!sh || this.cartTotal == null) return;
        const v = this.variants.find((x) => String(x.id) === String(this.currentVariantId())) || this.variants[0];
        if (!v || !v.available) {
          sh.box.hidden = true;
          this.measure();
          return;
        }
        const d = sh.box.dataset;
        const price = Number(v.cents || 0);
        const qty = this.currentQty();
        const gap = sh.threshold - (this.cartTotal + price * qty);
        let msg;
        let offerBag = false;
        if (gap <= 0) msg = d.msgFree;
        else if (sh.bagId && gap <= sh.bagPrice) {
          msg = d.msgBag;
          offerBag = true;
        } else if (gap <= price) msg = d.msgOne;
        else if (sh.bagId && gap <= price + sh.bagPrice) msg = d.msgOneBag;
        else msg = d.msgAmount;
        // nói theo cả đơn ("Get 2 books…"), không nói "thêm 1 cuốn nữa" khi khách chưa bỏ cuốn nào vào giỏ
        const n = qty + 1;
        sh.text.textContent = (msg || '')
          .replace('[n]', String(n))
          .replace('[nouns]', n > 1 ? d.nouns || d.noun || 'items' : d.noun || 'item')
          .replace('[noun]', d.noun || 'item')
          .replace('[threshold]', d.thresholdLabel || this.money(sh.threshold))
          .replace('[amount]', this.money(gap));
        sh.box.classList.toggle('is-done', gap <= 0);
        if (sh.add) sh.add.hidden = !offerBag;
        if (sh.box.hidden) {
          sh.box.hidden = false;
          this.measure();
        }
      }

      async addBag() {
        const sh = this.ship;
        if (!sh || !sh.bagId || sh.add.disabled) return;
        sh.add.disabled = true;
        const drawer = document.querySelector('cart-drawer');
        const sections =
          drawer && typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map((x) => x.id)
            : ['cart-icon-bubble'];
        try {
          const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(sh.bagId), quantity: 1, sections, sections_url: window.location.pathname }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || 'Cart error');
          // 26/09 (founder: bấm Quick add xong giỏ hiện giao diện trang /cart): PHÁT tín hiệu cartUpdate TRƯỚC rồi mới vẽ ngăn giỏ, đúng thứ tự nút mua Shrine.
          // Vẽ trước thì danh sách hàng MỚI của ngăn giỏ nhận tín hiệu, tải /cart?section_id=main-cart-items (HTML trang giỏ) và ghi đè lên ngăn giỏ.
          const pub = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
          if (pub) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-sticky-ship', productVariantId: Number(sh.bagId), cartData: data });
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data, true); // cập nhật giỏ + số trên icon, không bật giỏ ra
          }
          if (!pub) this.refreshCart();
        } catch (e) {
          console.error('[hb-sticky-buy]', e);
          if (this.error) {
            this.error.textContent = e.message;
            this.error.hidden = false;
            clearTimeout(this.errorTimer);
            this.errorTimer = setTimeout(() => (this.error.hidden = true), 6000);
          }
        }
        sh.add.disabled = false;
      }

      measure() {
        const h = this.classList.contains('is-hidden') ? 0 : this.offsetHeight;
        document.documentElement.style.setProperty('--hb-sticky-h', `${h}px`);
      }
    }
  );
}
};
// định nghĩa khi HTML đã dựng xong (readyState 'interactive' đến TRƯỚC các script defer), để phần con của thanh đã có
if (document.readyState === 'loading') {
  document.addEventListener('readystatechange', function hbOnReady() {
    if (document.readyState === 'loading') return;
    document.removeEventListener('readystatechange', hbOnReady);
    hbDefineSticky();
  });
} else {
  hbDefineSticky();
}
